// Azure Static Web Apps exposes /.auth/me with the current user.
// Returns null when no one is signed in.

export interface ClientPrincipal {
  identityProvider: string;
  userId: string;
  userDetails: string;
  userRoles: string[];
}

export async function getCurrentUser(): Promise<ClientPrincipal | null> {
  try {
    const res = await fetch('/.auth/me');
    if (!res.ok) return null;
    const json = await res.json();
    const principal = json?.clientPrincipal;
    if (!principal) return null;
    return principal as ClientPrincipal;
  } catch {
    return null;
  }
}

export function isAdmin(p: ClientPrincipal | null): boolean {
  return !!p && (p.userRoles ?? []).map((r) => r.toLowerCase()).includes('admin');
}
